import React from 'react';
const comparisonRows = [{
  situation: 'Tu cursada',
  without: 'Todo más disperso',
  with: 'Más orden y claridad'
}, {
  situation: 'Parciales',
  without: 'Improvisación constante',
  with: 'Planificación más clara'
}, {
  situation: 'Finales',
  without: 'Sin saber qué priorizar',
  with: 'Checklist y enfoque previo'
}, {
  situation: 'TPs y prácticos',
  without: 'Armás todo desde cero',
  with: 'Plantillas para organizarte mejor'
}, {
  situation: 'Seguimiento',
  without: 'Sin control real del avance',
  with: 'Planillas y control por materia'
}, {
  situation: 'Organización diaria',
  without: 'Te organizás como podés',
  with: 'Planner y calendario editable'
}];
const blocks = [{
  num: '01',
  emoji: '🗓️',
  title: 'Planner Académico Editable',
  desc: 'Organizá materias, objetivos, semanas de cursada, prácticas y fechas clave en un solo lugar.'
}, {
  num: '02',
  emoji: '📅',
  title: 'Calendario Académico Editable',
  desc: 'Visualizá parciales, finales, entregas y planificación mensual con más claridad.'
}, {
  num: '03',
  emoji: '📊',
  title: 'Planillas de Seguimiento',
  desc: 'Llevá control del avance por materia, preparación de parciales y estado real de tu estudio.'
}, {
  num: '04',
  emoji: '📝',
  title: 'Plantillas Editables de Estudio y Evaluación',
  desc: 'Incluye resúmenes inteligentes, checklists pre-examen, evaluación kinésica y registro de prácticas.'
}];
const assets = ['Planner Editable', 'Calendario Académico', 'Seguimiento de Materias', 'Seguimiento de Parciales', 'Organizador Semanal', 'Checklist Pre-Examen', 'Plan Intensivo 7/14/30'];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(239,246,255) 0%, rgb(255,255,255) 24%, rgb(239,246,255) 76%, rgb(255,255,255) 100%)'
  }} data-id="element-224">
      <div className="mx-auto max-w-4xl" data-id="element-225">
        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-226">
          ¿Qué agrega la{' '}
          <span className="text-blue-700" data-id="element-227">versión más completa?</span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-228">
          Todo lo del MegaPack Base, más un kit editable de organización
          académica para cursar, planificar, hacer seguimiento y estudiar con
          mucha más claridad.
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(59,130,246,0.2)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-229">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-230">
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-231">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-232">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-233">
                MegaPack Base
              </div>
              <div className="px-4 py-3 text-xs font-bold text-blue-700 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-234">
                Versión más completa
              </div>
            </div>

            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-235">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-236">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-237">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgb(239,246,255)'
            }} data-id="element-238">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-239">
          <div className="bg-blue-700 px-5 py-3" data-id="element-240">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-241">
              🏆 LA VERSIÓN MÁS COMPLETA INCLUYE:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-242">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-243">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-244">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-245">
                  <span className="block text-sm font-black text-gray-900" data-id="element-246">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-247">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(239,246,255)',
        border: '1px solid rgba(59,130,246,0.2)'
      }} data-id="element-248">
          <p className="text-xs font-bold text-blue-700 uppercase tracking-widest m-0 mb-3" data-id="element-249">
            📊 Recursos editables incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-250">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold text-blue-700 bg-white border border-blue-700/20 rounded-full px-3 py-1" data-id="element-251">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}